import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { QueryKey } from "@tanstack/react-query";

const IMAGE = "image";
const CREATE = "create";
const DELETE = "delete";
const GET_MANY = "getMany";

const MUTATION_KEYS = {
  [CREATE]: [IMAGE, CREATE],
  [DELETE]: [IMAGE, DELETE],
} as const satisfies Record<string, QueryKey>;

const QUERY_KEYS = createQueryKeys(IMAGE, {
  [GET_MANY]: null,
});

export { CREATE, DELETE, GET_MANY, IMAGE, MUTATION_KEYS, QUERY_KEYS };
